// Organizations v3 ring 0 (agent_docs/organizations_v3_prd.md B2): the org this browser acts in.
// Set from the user profile (AuthContext), cleared on sign-out, sent on every API call as the
// X-CellCog-Org header by the shared axios interceptor. The server checks membership on every
// request; this value is context, never proof. Ring 3's switcher writes it too.

export const ORG_HEADER = 'X-CellCog-Org';

const STORAGE_KEY = 'cellcog_current_org_id';

let currentOrgId = null;
try {
  currentOrgId = localStorage.getItem(STORAGE_KEY) || null;
} catch (e) {
  currentOrgId = null;
}

export const getCurrentOrgId = () => currentOrgId;

export const setCurrentOrgId = (orgId) => {
  currentOrgId = orgId || null;
  try {
    if (currentOrgId) {
      localStorage.setItem(STORAGE_KEY, currentOrgId);
    } else {
      localStorage.removeItem(STORAGE_KEY);
    }
  } catch (e) {
    /* storage unavailable: the in-memory value still rides this session's requests */
  }
};
